import CheckIcon from '@mui/icons-material/Check';
import { formatDateTime } from "../functions/formatDate";
import ConvSecToMin from "../functions/ConvSecToMin";
import CallTypeToIcon from "../functions/CallTypeToIcon";
import ButtonBoxDispositivi from '../components/DispositiviDataTable/ButtonBoxDispositivi';
import ButtonBoxUsers from "../components/UsersDatatable/ButtonBoxUsers";

const minWidthColumn = 160

const CallsLogHeader = {
  initialFieldName: "Device.Denominazione",
  initialFieldOrder: "asc",
  headers: [
    {
      field: "Device.Denominazione",
      headerName: "Dispositivo",
      flex: 1,
      minWidth: 160,
      resizable: false,
      headerAlign: "left",
      valueGetter: (cell) => {
        return cell.row.denominazioneDevice;
      }
    },
    {
        field: 'inizioChiamata',
        headerName: 'Data Chiamata',
        flex: 1,
        minWidth: minWidthColumn,
        resizable: false,
        headerAlign: 'right',
        align: 'right',
        valueGetter: (cell) => {
            return formatDateTime(cell.value);
        }
    },
    {
      field: "durata",
      headerName: "Durata Chiamata",
      type: "number",
      flex: 1,
      minWidth: minWidthColumn,
      resizable: false,
      headerAlign: "right",
      align: "right",
      valueGetter: (cell) => {
        return ConvSecToMin(cell.value);
      }
    },
    {
      field: "TipoDiChiamata.Descrizione",
      headerName: "Tipo Chiamata",
      flex: 1,
      minWidth: minWidthColumn,
      resizable: false,
      headerAlign: "right",
      align: "right",
      valueGetter: (cell) => {
        return cell.row.descrizioneTipoChiamata;
      }
    },
    {
      field: "numeroDestinatario",
      headerName: "Mittente/Destinatario",
      flex: 1,
      minWidth: minWidthColumn,
      resizable: false,
      headerAlign: "right",
      align: "right"
    }
  ]
};

const DispositiviHeader = {
    intialFieldName: 'denominazione',
    initialFieldOrder: 'asc',
    headers: [
    { 
        field: 'idUtente',
        headerName: 'ID Dispositivo',
        minWidth: minWidthColumn,
        flex: 1, 
        resizable: false,
        headerAlign: 'left'  
    },
    {
      field: "denominazione",
      headerName: "Denominazione",
      minWidth: minWidthColumn,
      flex: 1,
      resizable: false,
      headerAlign: "left",
      align: "left"
    },
    {
      field: "tipiChiamataUtente",
      headerName: "Permessi Associati",
      sortable: false,
      type: "number",
      minWidth: minWidthColumn,
      flex: 1,
      renderCell: (x) => {
        return CallTypeToIcon(x)
 
      },
      resizable: false,
      headerAlign: "center",
      align: "center"
    },
    {
        field: 'abilitaRecuperoChiamatePreInstallazione',
        headerName: 'Recupero pregresso all\'installazione',
        sortable: false,
        minWidth: minWidthColumn,
        flex: 1,
        resizable: false,
        renderCell: (x) =>  {
           return (x.value === true ? <CheckIcon color="primary"/> : <></>) 
        },
        headerAlign: 'center',
        align: 'center'
    },
    {
      field: "dispositivoAbilitato",
      headerName: "Abilitato",
      sortable: false,
      minWidth: minWidthColumn,
      flex: 1,
      resizable: false,
      renderCell: (x) => {
        return x.value === true ? <CheckIcon color="primary"/> : <></>;
      },
      headerAlign: "center",
      align: "center",
    },
    {
      field: "gestioneDispositivi",
      type: "actions",
      headerName: "",
      minWidth: minWidthColumn,
      flex: 1,
      resizable: false,
      editable: false,
      getActions: (x) => {
        //tabIndex permette di identificare quale Row è stata chiamata nel dataTable
        return [<ButtonBoxDispositivi activeRow={x.id} rowInfo={x.row}/>];
      },
      headerAlign: "center",
      align: "center",
    }
  ],
};

const UsersHeader = {
  initialFieldName: 'username',
  initialFieldOrder: 'asc',
  headers: [
    {
      field: "username",
      headerName: "Username",
      flex: 1,
      resizable: false,
      minWidth: minWidthColumn,
      headerAlign: "left"
    },
    {
      field: "lastName",
      headerName: "Cognome",
      flex: 1,
      resizable: false,
      minWidth: minWidthColumn,
      headerAlign: "left"
    },
    {
      field: "firstName",
      headerName: "Nome",
      flex: 1,
      resizable: false,
      minWidth: minWidthColumn,
      headerAlign: "left"
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      resizable: false,
      minWidth: minWidthColumn,
      headerAlign: "left"
    },
    {
      field: "phoneNumber",
      headerName: "Numero Telefono",
      flex: 1,
      resizable: false,
      minWidth: minWidthColumn,
      headerAlign: "left"
    },
    {
      field: "roles",
      headerName: "Ruoli",
      flex: 1,
      resizable: false,
      minWidth: minWidthColumn,
      headerAlign: "left",
      valueGetter: (cell) => {
        return cell.value.join(", ");
      } 
    },
    {
      field: "userActions",
      headerName: "",
      type: "actions",
      flex: 1,
      resizable: false,
      sortable: false,
      minWidth: minWidthColumn,
      getActions: (cell) => {
        return [<ButtonBoxUsers activeRow={cell.id} rowInfo={cell.row}/>];
      },
      headerAlign: "center",
      align: "center"
    }
  ]
};

export { CallsLogHeader, DispositiviHeader, UsersHeader };
